import { IconProps } from "./types";

export default function IcoEdit({
	color = "#6B7280",
	width = "16",
	height = "16"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M12.8216 7.21885L13.1747 6.86572L12.1153 5.80635L10.1747 3.86572L9.11535 2.80635L8.76222 3.15947L8.05597 3.86572L1.83097 10.0907C1.50597 10.4157 1.26847 10.8188 1.13722 11.2595L0.0309741 15.022C-0.0471509 15.2845 0.0247241 15.5688 0.221599 15.7626C0.418474 15.9563 0.699724 16.0282 0.962224 15.9532L4.7216 14.847C5.16222 14.7157 5.56535 14.4782 5.89035 14.1532L12.1153 7.92822L12.8216 7.21885ZM4.99972 12.4813L4.71535 13.1907C4.59035 13.2876 4.44972 13.3595 4.29972 13.4063L1.85597 14.1251L2.57472 11.6845C2.61847 11.5313 2.69347 11.3907 2.79035 11.2688L3.49972 10.9845V11.9845C3.49972 12.2595 3.72472 12.4845 3.99972 12.4845H4.99972V12.4813ZM11.3341 0.584473L10.8841 1.0376L10.1778 1.74385L9.8216 2.09697L10.881 3.15635L12.8216 5.09697L13.881 6.15635L14.2341 5.80322L14.9403 5.09697L15.3935 4.64385C16.1747 3.8626 16.1747 2.59697 15.3935 1.81572L14.1653 0.584473C13.3841 -0.196777 12.1185 -0.196777 11.3372 0.584473H11.3341ZM9.85285 5.83447L5.35285 10.3345C5.1591 10.5282 4.84035 10.5282 4.6466 10.3345C4.45285 10.1407 4.45285 9.82197 4.6466 9.62822L9.1466 5.12822C9.34035 4.93447 9.6591 4.93447 9.85285 5.12822C10.0466 5.32197 10.0466 5.64072 9.85285 5.83447Z"
				fill={color}
			/>
		</svg>
	);
}
